<template>
<div :class="bem()">

    <GdInput
        type="tel"
        v-model="innerValue.number"
        v-bind="$attrs"
        v-on="$listeners"
        @input="onInput"
        maxlength="20"
        autocomplete="off"
        placeholder="输入手机号码"
    >
        <template slot="prepend">
            <Popover
                trigger="click"
                offset="4px"
                :modifiers="{
                    offset: {
                        offset: '-18px, 18px'
                    },
                    flip: {
                        enabled: false,
                    }
                }"
                :arrow="false"
                :visible.sync="showCountryList"
                placement="bottom-start">
                <label :class="bem('code', {active: showCountryList})">
                    {{ '+' + innerValue.code }}
                    <Icon name="gdd-caret-down"/>
                </label>
                <div :class="bem('country-list')" v-show="showCountryList" slot="content">
                    <ul>
                        <li
                            v-for="(country, index) in countries"
                            :key="index"
                            @click="selectCountry(country.code)"
                        >{{ country.name + ' +' + country.code }}</li>
                    </ul>
                </div>
            </Popover>
        </template>
    </GdInput>
</div>

</template>
<script>
import _Popover from "@gaoding/gdui/lib/popover";
import _Icon from "@gaoding/gdui/lib/icon";
import _Input from "@gaoding/gdui/lib/input";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import bemMixin from '../bem';
export default {
  name: 'g-phone-number',
  components: {
    GdInput: _Input,
    Icon: _Icon,
    Popover: _Popover
  },
  mixins: [bemMixin],
  model: {
    event: 'update',
    name: 'value'
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    countries: {
      type: Array,
      default: function _default() {
        return [{
          name: '中国',
          code: 86
        }, {
          name: '中国香港',
          code: 852
        }, {
          name: '中国澳门',
          code: 853
        }, {
          name: '中国台湾地区',
          code: 886
        }];
      }
    },
    loading: {
      type: Boolean,
      defalut: false
    },
    checked: {
      type: Boolean,
      defalut: false
    }
  },
  data: function data() {
    return {
      showCountryList: false,
      innerValue: _objectSpread({}, this.value)
    };
  },
  watch: {
    value: function value(_value) {
      if (_value) this.innerValue = _value;
    }
  },
  methods: {
    onInput: function onInput() {
      this.innerValue.number = this.innerValue.number.replace(/[^\w./-]/ig, '');
      this.$emit('update', this.innerValue);
    },
    selectCountry: function selectCountry(code) {
      this.innerValue.code = code;
      this.$emit('update', _objectSpread({}, this.innerValue));
    }
  }
};
</script>
<style>
/*
 * @Author: 天吾
 * @Date: 2019-01-23 16:29:55
 * @Last Modified by: 天吾
 * @Last Modified time: 2019-11-22 11:24:33
 */
/*
    size 统一用  sm base lg  表示,  对于不能满足的情况, 仿照衣服尺寸加上 x(EXTRA) 比如  font-size-xlg 表示特大
*/
.g-phone-number {
  width: 100%;
}
.g-phone-number__code {
  color: #000;
  display: flex;
  align-items: center;
  min-width: 36px;
}
.g-phone-number__code--active {
  color: #005cf9;
}
.g-phone-number__code .g-icon {
  font-size: 8px;
  width: 8px;
  margin-left: 2px;
}
.g-phone-number__country-list {
  height: 262px;
  width: 241px;
  border-radius: 2px;
  box-shadow: 0px 9px 9px 0 rgba(0, 92, 249, 0.08);
  background-color: #ffffff;
  border: solid 1px #81b0ff;
  overflow: scroll;
  z-index: 2;
}
.g-phone-number__country-list::-webkit-scrollbar {
  width: 8px;
  height: 0;
}
.g-phone-number__country-list::-webkit-scrollbar-track:vertical {
  border-radius: 2px;
  background-color: #ffffff;
}
.g-phone-number__country-list::-webkit-scrollbar-thumb:vertical {
  border-radius: 2px;
  background-color: #e4eeff;
  margin: 7px 0;
}
.g-phone-number__country-list ul {
  list-style: none;
  padding: 0;
}
.g-phone-number__country-list li {
  line-height: 44px;
  padding-left: 23px;
  cursor: pointer;
  list-style: none;
}
.g-phone-number__country-list li:hover {
  color: #ffffff;
  background-color: #81b0ff;
}
.g-phone-number .loading-status,
.g-phone-number .pass-status {
  background-size: contain;
  width: 16px;
  height: 16px;
  position: absolute;
  top: 15px;
  right: 15px;
}
.g-phone-number .loading-status {
  background-image: url('../assets/loading.gif');
}
.country-list-mask {
  opacity: 0;
  position: fixed;
  height: 200vh;
  width: 200vw;
  z-index: 1;
  top: -100%;
  left: -100%;
}

</style>
